import { VisuallyHidden } from '@piggybank/core';
import castArray from 'lodash/castArray';
import first from 'lodash/first';
import flatten from 'lodash/flatten';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import React from 'react';
import { reducei18n } from '../utils';
import Markdown from './Markdown';

const getTestId = (...args) => ['markdown', ...flatten(args)].join('-');

export const renderMarkdown = (
  translation = '',
  markdownVars = {}, // vars for i18n logic and template interpolation
  {
    ariaSuffixLabel = '', // add-on for accessibility
    currentFormValuePath, // for resolving relative path in conditions e.g. $parent
    mappedComponentsProps = {}, // props for all mapped components from rehype2react
    noBottomMargin,
    translationPath = [], // a reference path to where the translation is coming from
  } = {}
) => {
  if (isArray(translation)) {
    const arrayFirsti18n = first(
      reducei18n(translation, markdownVars, currentFormValuePath)
    );

    const { _index: conditionIndex, source: i18nContent } = arrayFirsti18n;

    return renderMarkdown(i18nContent, markdownVars, {
      mappedComponentsProps,
      currentFormValuePath,
      translationPath: [...castArray(translationPath), conditionIndex],
    });
  } else if (isPlainObject(translation)) {
    const { markdown } = translation;

    const markdownContent = isArray(markdown)
      ? first(reducei18n(markdown, markdownVars, currentFormValuePath))
      : markdown;

    if (isPlainObject(markdownContent)) {
      const {
        _index: conditionIndex = '',
        source,
        ...markdownSourceProps
      } = markdownContent;

      const testId =
        conditionIndex === ''
          ? getTestId(translationPath)
          : getTestId(translationPath, conditionIndex);

      return (
        <Markdown
          {...(!isEmpty(mappedComponentsProps) && { mappedComponentsProps })}
          data-testid={testId}
          markdownVars={{ ...markdownSourceProps, ...markdownVars }}
          noBottomMargin={noBottomMargin}
        >
          {source}
        </Markdown>
      );
    }

    return (
      <Markdown
        {...(!isEmpty(mappedComponentsProps) && { mappedComponentsProps })}
        data-testid={getTestId(translationPath)}
        markdownVars={markdownVars}
        noBottomMargin={noBottomMargin}
      >
        {markdownContent}
      </Markdown>
    );
  }

  return (
    <span data-testid={getTestId(translationPath)}>
      {translation}
      {!isEmpty(ariaSuffixLabel) && (
        <VisuallyHidden>{ariaSuffixLabel}</VisuallyHidden>
      )}
    </span>
  );
};
